import React, { Component } from 'react';
import { DomCustomImage, DomSelect, DomField, DomBoolCheckbox, DomCheckboxField, DomTextarea } from "../Services/formDOM";
import { checkInput, returnValue, hasValue, validateEmail } from "../Services/Validation";
import "./Body.scss";
import { apiURL, Environment } from "../Services/Base";
import Loading from "../Services/Loading/Loading";
import { GA_Push } from "../Services/GoogleAnalytics";
import { ios } from '../Services/Agent';


Object.filter = function (obj, predicate) {
    var result = {}, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key) && predicate(obj[key])) {
            result[key] = obj[key];
        }
    }

    return result;
};

export default class Body extends Component {
    constructor(props) {
        super();
        this.state = {
            isBusy: false,
            isLoading: false,
            captchaEnable: true,
            ImagePlaceholder: "צרפו תמונה משפחתית מהביקור באתר ( קבצי PNG, JPEG )",
            sendForm: {}

        }
        window.sendCallback = this.sendForm;
    }

    componentDidMount() {
        (() => {
            if (window.document.getElementById("GoogleRecap")) return;

            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = "GoogleRecap";
            script.async = 1;
            script.defer = 1;
            script.src = 'https://www.google.com/recaptcha/api.js';

            document.getElementsByTagName('head')[0].appendChild(script);
        })();

        this.setState({
            captchaEnable: !Environment().isLocalhost
        })
    }
    handleInputChange = (event) => {
        const handleChange = {
            [event.target.name]: {
                ...this.state[event.target.name],
                error: "",
                label: event.target.dataset.label ? event.target.dataset.label : "",
                value: (event.target.dataset && event.target.dataset.bool === "true" ? (this.state[event.target.name].value ? 0 : 1) : event.target.value)
            }
        }
        this.setState(handleChange);
    }
    changeImageLabel = (event) => {
        var allowdExtensions = ["jpg", "jpeg", "gif", "png"];
        var file = event.target.files[0];
        if (file) {
            if (file.size > 5242880) {
                alert("לא ניתן להעלות קבצים מעל 5mb")
                event.target.value = "";
                return false;
            }

            var isAllowd = false;
            allowdExtensions.forEach((extension) => {
                if (file.type.indexOf(extension) > -1) {
                    isAllowd = true;
                }
            })

            if (!isAllowd) {
                // alert("לא ניתן להעלות קבצים מסוג " + file.type);
                alert("אפשר לעלות רק קבצי תמונה");
                event.target.value = "";
                return false;
            }

            this.setState({
                ImagePlaceholder: file.name,
                FamilyImage: {
                    ...this.state.FamilyImage,
                    name: file.name,
                    value: file,
                    label: "",
                    id: "FamilyImage"
                }
            })
        } else {
            return false;
        }
    }

    addState = (stateName, isRequired, stateId) => {
        this.setState({
            [stateName]: {
                name: stateName,
                value: "",
                label: "",
                id: stateId,
                isRequired: !isRequired ? false : true
            }
        })
    }
    setErrorMessage = (target, errorMsg) => {
        if (!this.state[target.name]) return;

        this.setState({
            [target.name]: {
                ...target,
                error: errorMsg
            }
        });


    }



    saveAndValidate = async () => {
        if (this.state.isBusy) return;


        this.setState({
            isLoading: true,
            isBusy: true
        });

        let isError = false,
            j = 0,
            jsonBody = {},
            state = Object.filter(this.state, s => s.isRequired),
            fieldStateKeys = Object.keys(state);


        for (let s in state) {
            if (await !checkInput(state[s], this.setErrorMessage)) isError = true;
            j++;
        }

        for (let k in fieldStateKeys) {
            jsonBody = Object.assign(jsonBody, {
                [fieldStateKeys[k]]: returnValue(state[fieldStateKeys[k]])
            });
        }

        if (isError && j == fieldStateKeys.length) {
            this.setState({
                isLoading: false,
                isBusy: false
            })
            return;
        }



        this.setState({
            jsonBody,
            isLoading: true,
            isBusy: true
        }, () => {
            if (this.state.captchaEnable) {
                window.grecaptcha.execute()
            } else {
                this.sendForm();
            }
        })

    }
    sendForm = async () => {
        let formData = new FormData();
        const { jsonBody } = this.state;

        for (let k = 0; k < Object.keys(jsonBody).length; k++) {
            let _key = Object.keys(jsonBody)[k];
            formData.append(_key, jsonBody[_key]);
        }

        if (this.state.captchaEnable) {
            window.grecaptcha.reset()
        }

        let isExists = await fetch(`${apiURL}IsExists`, {
            method: 'POST',
            // headers: {
            //     'Content-Type': `application/json`
            // },
            // body: JSON.stringify(jsonBody)
            body: formData
        }).then(data => data.json());

        if (isExists) {
            this.setState({
                isLoading: false,
                isBusy: false
            })
            this.props.setPage("isExsits");
            return;
        }

        fetch(`${apiURL}Save`, {
            method: 'POST',
            // headers: {
            //     'Content-Type': `application/json`
            // },
            // body: JSON.stringify(jsonBody)
            body: formData
        }).then(data => data.json())
            .then(data => {
                this.setState({
                    isLoading: false,
                    isBusy: false
                })
                GA_Push("form_sent");
                if (this.state.captchaEnable) {
                    window.grecaptcha.reset();
                }
                this.props.setPage("thankyou");
            }).catch(error => {
                this.setState({
                    isLoading: false,
                    isBusy: false
                });
            });
    }

    render() {
        return (
            <div className={`main`}>
                <div className={`form-section`}>
                    <div className="padding">
                        <div className="title">
                            בחול המועד פסח ייפתחו עשרות אתרים,מוזיאונים ופארקים ללא תשלום בשיתוף בנק הפועלים ,כמדי שנה.                        </div>
                        <div className="sub-title">
                            ספרו לנו על החוויות המשותפות שצברתם במהלך הטיולים המשפחתיים
                            <br></br>
                            שלכם בחג ואולי תזכו בפרסים שווים – מנוי מטמון משפחתי של רשות שמורות
                            </div>

                        <div className="buzz-title">
                            הטבע והגנים או בפרס הראשון – זוג כרטיסי כניסה לגמר ה
                            <div className="euro"></div>
                        </div>
                        <div className="buzz-title-mobile">
                            הטבע והגנים או בפרס הראשון – זוג כרטיסי

                             כניסה לגמר ה
                             <div className="euro"></div>
                        </div>
                        <div className={`form  ${ios() != null ? "ios" : ""}`}>
                            <Loading showLoading={this.state.isLoading} />
                            <div className="tripinfo">
                                <DomTextarea
                                    type="text"
                                    max={3000}
                                    label="ספרו לנו על הטיול המשפחתי שלכם ועל החוויות המשותפת (עד 3000 מילה)"
                                    placeholder="ספרו לנו על הטיול המשפחתי שלכם ועל החוויות המשותפת (עד 3000 תווים)"
                                    name="MyTrip"
                                    id="MyTrip"
                                    className="field"
                                    isRequired
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state} />
                            </div>

                            <div className="addfile">
                                <DomCustomImage name="FamilyImage" id="FamilyImage" placeholder={this.state.ImagePlaceholder}
                                    isRequired
                                    onChange={this.changeImageLabel}
                                    onLoad={this.addState}  {...this.state} />
                            </div>
                            <div className="row">
                            <div className="personinfo">
                            <DomField
                                        type="text"
                                        max={64}
                                        label="שם מלא"
                                        placeholder="שם מלא"
                                        name="FullName"
                                        id="FullName"
                                        className="field"
                                        isRequired
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state} />
                                        </div>
                                {/* <div className="personinfo">
                                    
                                    <DomField
                                        type="tel"
                                        max={3}
                                        label="גיל"
                                        placeholder="גיל"
                                        name="Age"
                                        id="Age"
                                        className="field"
                                        isRequired
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state} />
                                </div> */}
                                <div className="personinfo">
                                    {/* <DomSelect

                                        max={3}
                                        label="מין"
                                        placeholder="מין"
                                        name="Gender"
                                        id="Gender"
                                        className="field"
                                        isRequired
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state} /> */}
                                    <DomField
                                        type="email"
                                        max={20}
                                        label='אימייל'
                                        placeholder='אימייל'
                                        name="Email"
                                        id="Email"
                                        className="field"
                                        isRequired
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state} />
                                </div>
                                <div className="personinfo">
                                    <DomField
                                        type="tel"
                                        max={10}
                                        label="טלפון"
                                        placeholder="טלפון"
                                        name="PhoneNumber"
                                        id="PhoneNumber"
                                        className="field"
                                        isRequired
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state} />
                                </div>
                                <div className="bottom">
                                    <div className="terms-web">
                                        <DomBoolCheckbox
                                            type="checkbox"
                                            name="Terms"
                                            id="Terms"
                                            className="field"
                                            label={`קראתי, הבנתי, ומסכים <a href=${`https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html`} target="_blank">לתנאי השימוש</a>, <a href=${`https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html`} target="_blank">למדיניות הפרטיות</a> ו<a href=${`https://z.ynet.co.il/mShort/commerce/API/BankHapoalim/takanon.htm`} target="_blank">לתקנון הפעילות</a>, וכן נותן הסכמתי למשלוח דברי פרסום לפי פרטיי לעיל`}
                                            value="0"
                                            isRequired
                                            onChange={this.handleInputChange}
                                            onLoad={this.addState}
                                            {...this.state}
                                        />
                                    </div>
                                    <div className="button-section">
                                        <div className="send" onClick={() => {
                                            this.saveAndValidate()
                                        }}>
                                            <div className="text">
                                                שלחו
                                            </div>
                                            <div className="g-recaptcha"
                                                data-callback="sendCallback"
                                                data-size="invisible"
                                                data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"></div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                <div className={`gamad ${window.navigator.userAgent.match(/SamsungBrowser/i) ? "note":""}`}>
                </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/Components/Body/Body.jsx